import { useIsMutating } from 'react-query'
import { Button } from '@mui/material'

import { mainButtonStyle } from 'common/styles'
import { useSessionDispatch, useSessionState } from 'context/Session'
import { useFlow } from 'utils/flow'

/**
 * Inline "Back" button rendered next to the primary (Continue/Submit) button when
 * the flow opts in via `back_button_inline`. Mirrors the floating arrow's behavior
 * (popStep, hidden on the first page and after submit). Returns null otherwise, so
 * placing it before a primary button is a no-op for flows using the default arrow.
 */
export default function InlineBackButton(): JSX.Element | null {
  const { data: flow } = useFlow()
  const { path, isSubmitted } = useSessionState()
  const [dispatch] = useSessionDispatch()
  const isMutating = useIsMutating()

  const shouldRender =
    flow?.back_button_inline === true && path.length > 0 && isSubmitted !== true

  if (!shouldRender) {
    return null
  }

  return (
    <Button
      className="inline-back-btn"
      variant="outlined"
      onClick={() => dispatch({ type: 'popStep' })}
      disabled={isMutating !== 0}
      // mr: auto pushes Back to the left edge while the primary button stays right.
      sx={{ ...mainButtonStyle.inlineButton, mr: 'auto' }}
    >
      Back
    </Button>
  )
}
